/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { ContentWrapper } from '@global/styles/grid';
import { Markdown } from '@components/Common';

import {
  ContactContainer,
  TextContainer,
  TextContent,
  Wrapper,
  FormContainer,
  Title,
  SubTitle,
} from './EmbedFormModal.styles';
import { EmbedFormProps } from './EmbedFormModal.types';
import { setItem } from 'helpers/storageHelper';

const EmbedFormModal = ({ title, subtitle }: EmbedFormProps) => {
  const handleSubmit = () => {
    setItem('on-tap-subscribed', 'true');
  };
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    const interval = setInterval(() => {
      const response = document.getElementById('g-recaptcha-response') as HTMLInputElement | null;
      if (response == null || response.value.trim() === '') {
        const elemsInput = document.getElementsByName('captcha_settings')[0] as
          | HTMLInputElement
          | undefined;
        if (elemsInput) {
          const elems = JSON.parse(elemsInput.value);
          elems.ts = JSON.stringify(new Date().getTime());
          elemsInput.value = JSON.stringify(elems);
        }
      }
    }, 500);

    return () => {
      clearInterval(interval);
      document.body.removeChild(script);
    };
  }, []);

  return (
    <ContactContainer>
      <ContentWrapper>
        <Wrapper>
          <TextContainer>
            <TextContent>
              {title && (
                <Title>
                  <Markdown text={title} textColor="white" />
                </Title>
              )}
              {subtitle && (
                <SubTitle>
                  <Markdown text={subtitle} textColor="white" />
                </SubTitle>
              )}
              <FormContainer id="hubspotFormContainer">
                <form
                  action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D1U000000y5wC"
                  method="POST"
                  onSubmit={handleSubmit}
                >
                  <input
                    type="hidden"
                    name="captcha_settings"
                    value='{"keyname":"web","fallback":"true","orgId":"00D1U000000y5wC","ts":""}'
                  />
                  <input type="hidden" name="oid" value="00D1U000000y5wC" />
                  <input type="hidden" name="retURL" value="https://wellnet.com/on-tap" />
                  <input
                    id="first_name"
                    placeholder="First Name"
                    maxLength={40}
                    name="first_name"
                    type="text"
                    required
                  />
                  <input
                    id="last_name"
                    placeholder="Last Name"
                    maxLength={80}
                    name="last_name"
                    type="text"
                    required
                  />
                  <input
                    id="email"
                    placeholder="Email"
                    maxLength={80}
                    name="email"
                    type="text"
                    required
                  />
                  <input
                    id="company"
                    placeholder="Company Name"
                    maxLength={40}
                    name="company"
                    type="text"
                    required
                  />
                  <input
                    id="title"
                    placeholder="Title"
                    maxLength={40}
                    name="title"
                    type="text"
                    required
                  />
                  <select id="state" name="state">
                    <option disabled selected value="">
                      State/Province
                    </option>
                    <option label="Alabama" value="Alabama">
                      Alabama
                    </option>
                    <option label="Alaska" value="Alaska">
                      Alaska
                    </option>
                    <option label="Arizona" value="Arizona">
                      Arizona
                    </option>
                    <option label="Arkansas" value="Arkansas">
                      Arkansas
                    </option>
                    <option label="California" value="California">
                      California
                    </option>
                    <option label="Colorado" value="Colorado">
                      Colorado
                    </option>
                    <option label="Connecticut" value="Connecticut">
                      Connecticut
                    </option>
                    <option label="Delaware" value="Delaware">
                      Delaware
                    </option>
                    <option label="Florida" value="Florida">
                      Florida
                    </option>
                    <option label="Georgia" value="Georgia">
                      Georgia
                    </option>
                    <option label="Hawaii" value="Hawaii">
                      Hawaii
                    </option>
                    <option label="Idaho" value="Idaho">
                      Idaho
                    </option>
                    <option label="Illinois" value="Illinois">
                      Illinois
                    </option>
                    <option label="Indiana" value="Indiana">
                      Indiana
                    </option>
                    <option label="Iowa" value="Iowa">
                      Iowa
                    </option>
                    <option label="Kansas" value="Kansas">
                      Kansas
                    </option>
                    <option label="Kentucky" value="Kentucky">
                      Kentucky
                    </option>
                    <option label="Louisiana" value="Louisiana">
                      Louisiana
                    </option>
                    <option label="Maine" value="Maine">
                      Maine
                    </option>
                    <option label="Maryland" value="Maryland">
                      Maryland
                    </option>
                    <option label="Massachusetts" value="Massachusetts">
                      Massachusetts
                    </option>
                    <option label="Michigan" value="Michigan">
                      Michigan
                    </option>
                    <option label="Minnesota" value="Minnesota">
                      Minnesota
                    </option>
                    <option label="Mississippi" value="Mississippi">
                      Mississippi
                    </option>
                    <option label="Missouri" value="Missouri">
                      Missouri
                    </option>
                    <option label="Montana" value="Montana">
                      Montana
                    </option>
                    <option label="Nebraska" value="Nebraska">
                      Nebraska
                    </option>
                    <option label="Nevada" value="Nevada">
                      Nevada
                    </option>
                    <option label="New Hampshire" value="New Hampshire">
                      New Hampshire
                    </option>
                    <option label="New Jersey" value="New Jersey">
                      New Jersey
                    </option>
                    <option label="New Mexico" value="New Mexico">
                      New Mexico
                    </option>
                    <option label="New York" value="New York">
                      New York
                    </option>
                    <option label="North Carolina" value="North Carolina">
                      North Carolina
                    </option>
                    <option label="North Dakota" value="North Dakota">
                      North Dakota
                    </option>
                    <option label="Ohio" value="Ohio">
                      Ohio
                    </option>
                    <option label="Oklahoma" value="Oklahoma">
                      Oklahoma
                    </option>
                    <option label="Oregon" value="Oregon">
                      Oregon
                    </option>
                    <option label="Pennsylvania" value="Pennsylvania">
                      Pennsylvania
                    </option>
                    <option label="Rhode Island" value="Rhode Island">
                      Rhode Island
                    </option>
                    <option label="South Carolina" value="South Carolina">
                      South Carolina
                    </option>
                    <option label="South Dakota" value="South Dakota">
                      South Dakota
                    </option>
                    <option label="Tennessee" value="Tennessee">
                      Tennessee
                    </option>
                    <option label="Texas" value="Texas">
                      Texas
                    </option>
                    <option label="Utah" value="Utah">
                      Utah
                    </option>
                    <option label="Vermont" value="Vermont">
                      Vermont
                    </option>
                    <option label="Virginia" value="Virginia">
                      Virginia
                    </option>
                    <option label="Washington" value="Washington">
                      Washington
                    </option>
                    <option label="West Virginia" value="West Virginia">
                      West Virginia
                    </option>
                    <option label="Wisconsin" value="Wisconsin">
                      Wisconsin
                    </option>
                    <option label="Wyoming" value="Wyoming">
                      Wyoming
                    </option>
                  </select>

                  <select id="lead_source" name="lead_source" hidden>
                    <option value="">--None--</option>
                    <option value="Website" selected>
                      Website
                    </option>
                  </select>

                  <div
                    className="g-recaptcha"
                    data-sitekey="6LfikasrAAAAAErkH38ROXCAIqYFkvsfXM44jvWT"
                    data-callback="onCaptchaSuccess"
                  />

                  <input type="submit" name="submit" value="Submit" />
                </form>
              </FormContainer>
            </TextContent>
          </TextContainer>
        </Wrapper>
      </ContentWrapper>
    </ContactContainer>
  );
};

export default EmbedFormModal;
